module.exports = __webpack_public_path__ + "static/img/img_20.4af8a30.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teamwork/images/img_20.webp
// module id = 64Yn
// module chunks = 5